import { DOMHelper } from "../Helpers/DOMHelper.js";
import { ShiftBmwModule } from "./ShiftBmwModule.js";
import { ShiftFCAModule } from "./ShiftFCAModule.js";
import { PmLogApi } from "../API/PmLogApi.js";

/**
 * @class top level to handle datalayers by brand, bmw, polaris, etc
 */
export class ShiftDatalayer {

    constructor(pmdrs, vehicle) {        
        this.pmdrs = pmdrs;
        this.vehicle = vehicle;
        this.initiatedForms = {};// to remember and not double fire it
        this.startedSections = {};// to remember and not double fire it
        this.modules = {};
        this.sessionId = this.pmdrs.getSessionId();
        this.ftid = null;//example 11ec8fe5-1204-4c9e-ae34-aaf51b014085:2023-12-13T08:02:36
        this.pmLogApi = null;
        // this.leadIdsSubmitted = [];
    }

    setFTID(ftid){
        return this.ftid = ftid;
    }

    getSessionId(){
        return this.sessionId;
    }

    getDealId(){
        if(!this.ftid) return null;

        // Split the string by the colon separator
        const parts = this.ftid.split(':');
          
        // Return the first part (the UUID)
        return parts[0];
    }

    getDealType(){
        return this.currentDealType;
    }

    init() {        
        //register modules
        this.pmLogApi = new PmLogApi(this.pmdrs);
        switch(this.pmdrs.getOEM().toLowerCase()){
            case 'bmwmotorrad':
                let bmwModule = new ShiftBmwModule(this); 
                if(bmwModule.init()){
                    this.modules['bmw'] = bmwModule; 
                }
                break;
            case 'fca':
                let fcaModule = new ShiftFCAModule(this); 
                if(fcaModule.init()){
                    this.modules['fca'] = fcaModule; 
                }
                break;
        }        
    }

    fireEvent(eventName, params){
        if(params?.dealType){
            this.currentDealType = params.dealType;
        }

        if(params?.ftid){
            this.setFTID(params.ftid);
        }
        
        // Prevent duplicate formSubmission events for the same leadId
        // if(eventName === "formSubmission" && params?.leadId){
        //     if(this.leadIdsSubmitted.includes(params.leadId)){
        //         console.info(`ShiftDatalayer: leadId ${params.leadId} already submitted, skipping duplicate formSubmission event.`);
        //         return;
        //     }
        //     this.leadIdsSubmitted.push(params.leadId);
        // }

        const functionName = eventName + "Event";
        for (let moduleKey in this.modules) {
            const module = this.modules[moduleKey];
            if(typeof module[functionName] === 'function'){
                let response = module[functionName](params);
                console.log(`ShiftDatalayer fireEvent [${eventName}]`, response);
                this.pmLogApi.send(response, "shift",
                    (logRsp) => {
                        let rsp = JSON.parse(logRsp);
                        console.log(rsp);
                    },
                    (error) => {
                        console.log(error);
                    }
                );
            }
        }
    }

    getVehicleDetails() {
        const v = this.vehicle;
        let vehicleDetails = {
            status: v.condition, //condition
            year: v.year,
            make: v.make,
            model: v.model + " " + v.trim,
            exteriorColor: "",//we don't have it
            vin: v.vin,
            msrp: v.retailPrice || v.pricing.data.internet || 0,
            displayedPrice: v.finalPrice
        };
        return vehicleDetails;
    }
}